import { Component } from '@angular/core';
import { WindowComponent } from "sharedFeatures/window";
import { FeedbackSentBodyComponent } from './feedback-sent-body.component';

@Component(
    {
        selector: 'feedback-sent',
        templateUrl: '../../window/window.component.html',
        styleUrls: ['../../window/window.component.less']
    })
export class FeedbackSentComponent extends WindowComponent {

    width = 248;
    height = 50;
    cornerRadius = 10;
    modal = false;

    testId = 'FeedbackNotificationPopup';

    windowContentBody = FeedbackSentBodyComponent;

    getBodyComponent(): FeedbackSentBodyComponent {
        return <FeedbackSentBodyComponent>super.getBodyComponent();
    }
}
